module.exports = __webpack_public_path__ + "img/GT10D.06f5f8b0.png";